import { render, staticRenderFns } from "./BackgroundChecksTableTop.vue?vue&type=template&id=c3b09e0a&lang=pug"
import script from "./BackgroundChecksTableTop.vue?vue&type=script&lang=ts"
export * from "./BackgroundChecksTableTop.vue?vue&type=script&lang=ts"
import style0 from "./BackgroundChecksTableTop.vue?vue&type=style&index=0&id=c3b09e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports